module.exports = __webpack_public_path__ + "assets/img/imte3.94083eaf.png";